export default "__VITE_ASSET__D7N0hlCi__"